enum opacities {
   OPAQUE = 0,
   TRANSLUSCENT = 1,
   TRANSPARENT = 2
};

export default opacities;
